module.exports = __webpack_public_path__ + "img/case-ct_pacecapsule_top.f03bf19.png";